import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getArticulos,
  getArticulosFiltered,
  updateArticulo,
  insertArticulo,
  deleteArticulo,
  getArticuloById,
  getArticulosProdcutosByArticuloId,
  deleteArticuloProducto,
  insertArticulosProductos,
  getArticulosFaltantes,
  updateArticulosStock,
  getArticulosVentas,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_ARTICULOS() {
  try {
    const articulosData = yield call(getArticulos)
    if (articulosData.ok) {
      yield put({
        type: actions.ARTICULOS_LOAD_SUCCEEDED,
        payload: articulosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar artículos')
      put({
        type: actions.ARTICULOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ARTICULOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ARTICULOS_FALTANTES() {
  try {
    const articulosFaltantesData = yield call(getArticulosFaltantes)
    if (articulosFaltantesData.ok) {
      yield put({
        type: actions.ARTICULOS_FALTANTES_LOAD_SUCCEEDED,
        payload: articulosFaltantesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar artículos faltantes')
      put({
        type: actions.ARTICULOS_FALTANTES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ARTICULOS_FALTANTES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ARTICULOS_FILTERED(action) {
  try {
    const articulosData = yield call(getArticulosFiltered, action.payload)
    if (articulosData.ok) {
      yield put({
        type: actions.ARTICULOS_FILTERED_LOAD_SUCCEEDED,
        payload: articulosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar artículos')
      put({
        type: actions.ARTICULOS_FILTERED_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ARTICULOS_FILTERED_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ARTICULOS_VENDIDOS(action) {
  try {
    const articulosData = yield call(getArticulosVentas, action.payload)
    if (articulosData.ok) {
      yield put({
        type: actions.ARTICULOS_VENDIDOS_LOAD_SUCCEEDED,
        payload: articulosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar artículos')
      put({
        type: actions.ARTICULOS_VENDIDOS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ARTICULOS_VENDIDOS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_ARTICULO(action) {
  try {
    const articuloObj = yield call(insertArticulo, action.payload)
    if (articuloObj.ok) {
      putMessage(messageType.SUCCESS, 'Artículo creado correctamente')
      yield put({
        type: actions.ARTICULO_INSERT_SUCCEEDED,
        payload: articuloObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Artículo')
      yield put({
        type: actions.ARTICULO_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Artículo')
    yield all([
      put({
        type: actions.ARTICULO_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ARTICULO(action) {
  try {
    const articuloObj = yield call(updateArticulo, action.payload)
    if (articuloObj.ok) {
      putMessage(messageType.SUCCESS, 'Artículo modificado correctamente')
      yield put({
        type: actions.ARTICULO_UPDATE_SUCCEEDED,
        payload: articuloObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Artículo')
      yield put({
        type: actions.ARTICULO_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Artículo')
    yield all([
      put({
        type: actions.ARTICULO_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ARTICULO(action) {
  try {
    const articuloResult = yield call(deleteArticulo, action.payload)
    if (articuloResult.ok) {
      putMessage(messageType.SUCCESS, 'Artículo eliminado correctamente')
      yield put({
        type: actions.ARTICULO_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Artículo')
      yield put({
        type: actions.ARTICULO_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Artículo')
    yield all([
      put({
        type: actions.ARTICULO_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ARTICULO_BY_ID(action) {
  try {
    const articuloData = yield call(getArticuloById, action.payload)
    if (articuloData.ok) {
      yield put({
        type: actions.ARTICULO_BYID_LOAD_SUCCEEDED,
        payload: articuloData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Artículo')
      put({
        type: actions.ARTICULO_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ARTICULO_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ARTICULOS_PRODUCTOS_BY_ID(action) {
  try {
    const articuloProductoData = yield call(getArticulosProdcutosByArticuloId, action.payload)
    if (articuloProductoData.ok) {
      yield put({
        type: actions.ARTICULO_PRODUCTO_BYID_LOAD_INSERT_SUCCEEDED,
        payload: articuloProductoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Artículo Productos')
      put({
        type: actions.ARTICULO_PRODUCTO_BYID_LOAD_INSERT_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ARTICULO_PRODUCTO_BYID_LOAD_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ARTICULO_PRODUCTO(action) {
  try {
    const articuloProductoResult = yield call(deleteArticuloProducto, action.payload)
    if (articuloProductoResult.ok) {
      putMessage(messageType.SUCCESS, 'Artículo Producto eliminado correctamente')
      yield put({
        type: actions.ARTICULO_PRODUCTO_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Artículo Producto')
      yield put({
        type: actions.ARTICULO_PRODUCTO_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Artículo Producto')
    yield all([
      put({
        type: actions.ARTICULO_PRODUCTO_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_ARTICULOS_PRODUCTOS(action) {
  try {
    const articulosProductosObj = yield call(insertArticulosProductos, action.payload)
    if (articulosProductosObj.ok) {
      putMessage(messageType.SUCCESS, 'Artículo Producto creado correctamente')
      yield put({
        type: actions.ARTICULOS_PRODUCTOS_INSERT_SUCCEEDED,
        payload: articulosProductosObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Artículo Producto')
      yield put({
        type: actions.ARTICULOS_PRODUCTOS_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Artículo Producto')
    yield all([
      put({
        type: actions.ARTICULOS_PRODUCTOS_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_STOCK_ARTICULO(action) {
  try {
    const articuloObj = yield call(updateArticulosStock, action.payload)
    if (articuloObj.ok) {
      putMessage(messageType.SUCCESS, 'Stock de artículos modificado correctamente')
      yield put({
        type: actions.ARTICULO_STOCK_UPDATE_SUCCEEDED,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Stock')
      yield put({
        type: actions.ARTICULO_STOCK_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Stock')
    yield all([
      put({
        type: actions.ARTICULO_STOCK_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.ARTICULOS_LOAD_REQUESTED, GET_ARTICULOS),
    takeEvery(actions.ARTICULOS_FALTANTES_LOAD_REQUESTED, GET_ARTICULOS_FALTANTES),
    takeEvery(actions.ARTICULOS_FILTERED_LOAD_REQUESTED, GET_ARTICULOS_FILTERED),
    takeEvery(actions.ARTICULOS_VENDIDOS_LOAD_REQUESTED, GET_ARTICULOS_VENDIDOS),
    takeEvery(actions.ARTICULO_INSERT_REQUESTED, INSERT_ARTICULO),
    takeEvery(actions.ARTICULO_UPDATE_REQUESTED, UPDATE_ARTICULO),
    takeEvery(actions.ARTICULO_DELETE_REQUESTED, DELETE_ARTICULO),
    takeEvery(actions.ARTICULO_BYID_LOAD_REQUESTED, GET_ARTICULO_BY_ID),
    takeEvery(actions.ARTICULO_PRODUCTO_BYID_LOAD_INSERT_REQUESTED, GET_ARTICULOS_PRODUCTOS_BY_ID),
    takeEvery(actions.ARTICULO_PRODUCTO_DELETE_REQUESTED, DELETE_ARTICULO_PRODUCTO),
    takeEvery(actions.ARTICULOS_PRODUCTOS_INSERT_REQUESTED, INSERT_ARTICULOS_PRODUCTOS),
    takeEvery(actions.ARTICULO_STOCK_UPDATE_REQUESTED, UPDATE_STOCK_ARTICULO),
  ])
}
